import { Action } from '@ngrx/store';

export enum MonitorLivePollingActionTypes {
  StartMonitorPolling = '[Live] StartDealMonitor',
  StopMonitorPolling = '[Live] StopDealMonitor',
}

export class MonitorLivePollingStart implements Action {
  public readonly type = MonitorLivePollingActionTypes.StartMonitorPolling;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}
}

export class MonitorLivePollingStop implements Action {
  public readonly type = MonitorLivePollingActionTypes.StopMonitorPolling;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}
}
